import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppContext } from '../../../app/Context';
import routes from '../../../routes/router';
import { getUrl } from '../../../db/shared';

const useUnauthenticated = () => {
  const navigate = useNavigate();

  const { presentationId, activeSlideId, session } = useAppContext();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(
    function navigateToUsers() {
      if (!presentationId) return;
      if (!activeSlideId) return;

      if (!(session && session.token)) {
        setIsLoading(false);
        return;
      }

      const url = getUrl(presentationId, activeSlideId) ?? routes.home.url();
      navigate(url, { replace: true });
    },
    [presentationId, activeSlideId, navigate, session]
  );

  return { isLoading };
};

export default useUnauthenticated;
